/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ trial_day_number: NonNullable<unknown> }} Onboarding_Paywall_Start_Triasl_BtnInputs */

const en_onboarding_paywall_start_triasl_btn = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Start ${i?.trial_day_number}-Day Free Trail`)
};

const ar_onboarding_paywall_start_triasl_btn = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ابدأ تجربة مجانية لمدة ${i?.trial_day_number} يومًا`)
};

const de_onboarding_paywall_start_triasl_btn = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Start ${i?.trial_day_number}-Day Free Trail`)
};

const es_onboarding_paywall_start_triasl_btn = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Empieza la prueba gratuita de ${i?.trial_day_number} días`)
};

const fr_onboarding_paywall_start_triasl_btn = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Commencer votre essai de ${i?.trial_day_number} jours`)
};

const it_onboarding_paywall_start_triasl_btn = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inizia la prova gratuita di ${i?.trial_day_number} giorni`)
};

const ja_onboarding_paywall_start_triasl_btn = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trial_day_number}日間無料トライアルを開始`)
};

const ko_onboarding_paywall_start_triasl_btn = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trial_day_number}일 무료 체험 시작하기`)
};

const pt_br_onboarding_paywall_start_triasl_btn = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Comece seus ${i?.trial_day_number} dias de teste grátis`)
};

const ru_onboarding_paywall_start_triasl_btn = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Начать ${i?.trial_day_number}-дневный бесплатный период`)
};

const th_onboarding_paywall_start_triasl_btn = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เริ่มทดลองใช้งานฟรี ${i?.trial_day_number} วัน`)
};

const tr_onboarding_paywall_start_triasl_btn = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trial_day_number}-Günlük Ücretsiz Denemeye Başla`)
};

const zh_cn_onboarding_paywall_start_triasl_btn = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`开始 ${i?.trial_day_number} 天免费试用`)
};

const zh_tw_onboarding_paywall_start_triasl_btn = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`開始 ${i?.trial_day_number} 天免費試用`)
};

/**
* | output |
* | --- |
* | "Start {trial_day_number}-Day Free Trail" |
*
* @param {Onboarding_Paywall_Start_Triasl_BtnInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onboarding_paywall_start_triasl_btn = /** @type {((inputs: Onboarding_Paywall_Start_Triasl_BtnInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Paywall_Start_Triasl_BtnInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_paywall_start_triasl_btn(inputs)
	if (locale === "ar") return ar_onboarding_paywall_start_triasl_btn(inputs)
	if (locale === "de") return de_onboarding_paywall_start_triasl_btn(inputs)
	if (locale === "es") return es_onboarding_paywall_start_triasl_btn(inputs)
	if (locale === "fr") return fr_onboarding_paywall_start_triasl_btn(inputs)
	if (locale === "it") return it_onboarding_paywall_start_triasl_btn(inputs)
	if (locale === "ja") return ja_onboarding_paywall_start_triasl_btn(inputs)
	if (locale === "ko") return ko_onboarding_paywall_start_triasl_btn(inputs)
	if (locale === "pt_br") return pt_br_onboarding_paywall_start_triasl_btn(inputs)
	if (locale === "ru") return ru_onboarding_paywall_start_triasl_btn(inputs)
	if (locale === "th") return th_onboarding_paywall_start_triasl_btn(inputs)
	if (locale === "tr") return tr_onboarding_paywall_start_triasl_btn(inputs)
	if (locale === "zh_cn") return zh_cn_onboarding_paywall_start_triasl_btn(inputs)
	return zh_tw_onboarding_paywall_start_triasl_btn(inputs)
});